import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { startBookingRumView } from './datadogRumBooking.js'

/**
 * Tracks Datadog RUM views for each in-app (memory router) navigation, with segment context on each view.
 *
 * @param {{ segment: Record<string, unknown>, routeMap: Record<string, string> }} options
 */
export function useDatadogBookingRouteView({ segment, routeMap }) {
  const location = useLocation()

  useEffect(() => {
    const viewName = routeMap[location.pathname]
    if (!viewName) {
      return
    }
    startBookingRumView(viewName, segment)
  }, [location.pathname, segment, routeMap])
}
